<template>
  <v-app-bar app elevation="1" color="white" height="70">
    <v-container fluid class="d-flex align-center">
      <!-- Reduced logo size and improved responsive layout -->
      <router-link to="/" class="d-flex align-center">
        <img 
          src="/images/Logotipo.png" 
          alt="Logo Estudio Gallo Puló" 
          class="logo-img"
        >
      </router-link>

      <v-spacer></v-spacer>

      <!-- Desktop navigation with better responsive design -->
      <div class="d-none d-md-flex align-center">
        <v-btn
          v-for="item in navItems"
          :key="item.text"
          @click="handleNavigation(item)"
          variant="text"
          class="mx-2 nav-btn"
          :class="item.class"
        >
          {{ item.text }}
        </v-btn>
      </div>

      <!-- Mobile menu button -->
      <v-app-bar-nav-icon 
        class="d-md-none" 
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-container>
  </v-app-bar>

  <!-- Mobile navigation drawer -->
  <v-navigation-drawer
    v-model="drawer"
    temporary
    location="right"
    class="d-md-none"
  >
    <v-list>
      <v-list-item
        v-for="item in navItems"
        :key="item.text"
        @click="handleNavigation(item)"
      >
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const drawer = ref(false)
const router = useRouter()

const handleNavigation = (item) => {
  if (item.href && item.href.startsWith('#')) {
    // If it's a hash link, navigate to home first then scroll to section
    if (router.currentRoute.value.path !== '/') {
      router.push('/').then(() => {
        setTimeout(() => {
          const element = document.querySelector(item.href)
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
          }
        }, 100)
      })
    } else {
      // Already on home page, just scroll to section
      const element = document.querySelector(item.href)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  } else if (item.to) {
    // Regular route navigation
    router.push(item.to)
  }
  drawer.value = false
}

const navItems = [
  { text: 'Quiénes Somos', href: '#nosotros' },
  { text: 'Servicios', href: '#servicios' },
  { text: 'Responsabilidad Social Empresarial', href: '#rse' },
  { text: 'Novedades', href: '#novedades' },
  { text: 'Acceso de Clientes', to: '/login', class: 'text-brand-orange font-weight-bold' },
  { text: 'Contacto', to: '/contacto', class: 'bg-brand-orange text-white' }
]
</script>

<style scoped>
.logo-img {
  height: 45px;
  width: auto;
  max-width: 200px;
}

.nav-btn {
  text-transform: none !important;
  font-weight: 500;
}

.nav-btn:hover {
  color: var(--color-orange-primary) !important;
}

/* Responsive logo sizing */
@media (max-width: 600px) {
  .logo-img {
    height: 35px;
    max-width: 150px;
  }
}
</style>
